// removed by extract-text-webpack-plugin
module.exports = {"sidebar":"pic6c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/PageSidebar/PageSidebar.scss
// module id = ./src/components/Page/PageSidebar/PageSidebar.scss
// module chunks = 5